import React from "react";
import WrapperInput, { IWrapperInput } from "./WrapperInput";
import {
  FormHelperText,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
} from "@mui/material";

interface ISelectInput extends Omit<IWrapperInput, "children"> {
  errorMessage?: string | undefined;
  disabled?: boolean;
  readOnly?: boolean;
  value?: string;
  placeholder?: string;
  defaultValue?: string;
  options: { value: string; label: string }[];
  onChange?: (val: string) => void;
}

function SelectInput({
  id,
  label,
  labelWidth = "20%",
  required,
  placeholder,
  errorMessage,
  value,
  defaultValue,
  options,
  onChange,
  ...wrapperProps
}: ISelectInput) {
  return (
    <WrapperInput
      id={id}
      label={label}
      required={required}
      labelWidth={labelWidth}
      {...wrapperProps}
    >
      <Stack sx={{ width: "100%" }}>
        <Select
          value={value}
          defaultValue={defaultValue}
          placeholder={placeholder}
          onChange={(e: SelectChangeEvent) => {
            onChange?.(e.target.value as string);
          }}
          fullWidth
          size="small"
          sx={{
            height: "45px",
            border: "2px solid",
            borderColor: "divider",
            "& fieldset": { border: "none", outline: "none" },
          }}
        >
          {options.map((option) => {
            return (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            );
          })}
        </Select>
        {errorMessage && (
          <FormHelperText error sx={{ mx: 1.75, fontStyle: "italic" }}>
            {errorMessage}
          </FormHelperText>
        )}
      </Stack>
    </WrapperInput>
  );
}

export default SelectInput;
